import { useEffect, useState } from "react";

import type { PendingDocument } from "@shared/api/server/gs3Server";

import { LegalDocumentModal } from "./LegalDocumentModal";

export const LegalDocumentsGuard = () => {
  const [pendingDocuments, setPendingDocuments] = useState<PendingDocument[]>(
    [],
  );
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const handleLegalDocumentRequired = (
      event: CustomEvent<{ pendingDocuments: PendingDocument[] }>,
    ) => {
      setPendingDocuments((prev) => {
        if (prev.length > 0) return prev;

        setCurrentIndex(0);
        return event.detail.pendingDocuments;
      });
    };

    window.addEventListener(
      "legal-document-required",
      handleLegalDocumentRequired as EventListener,
    );

    return () => {
      window.removeEventListener(
        "legal-document-required",
        handleLegalDocumentRequired as EventListener,
      );
    };
  }, []);

  const handleAccepted = () => {
    if (currentIndex < pendingDocuments.length - 1) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      window.location.reload();
    }
  };

  if (pendingDocuments.length === 0) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4">
      <LegalDocumentModal
        document={pendingDocuments[currentIndex]}
        onAccepted={handleAccepted}
      />
    </div>
  );
};
